import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Importer le fichier CSS pour les animations

export const Services = (props) => {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialiser AOS avec une durée d'animation de 1 seconde
  }, []);

  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Nos Services</h2>
          <p>
            Découvrez nos services spécialisés pour donner vie à vos projets visuels : de la production vidéo à la photographie, en passant par la location de studio entièrement équipé.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.name}-${i}`}
                  className="col-md-4"
                  data-aos="fade-up" // Animation AOS
                >
                  <img
                    src={d.img}
                    alt={d.name}
                    style={{ width: "300px", height: "240px" }}
                  />
                  <div className="service-desc">
                    <h3 style={{ textDecoration: "underline" }}>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
